import { AUS_DOMAIN, NZ_DOMAIN, US_DOMAIN } from '../constants';

const {
  REACT_APP_CLIENT_CENTER_HOST,
  REACT_APP_CLIENT_CENTER_HOST_AUS,
  REACT_APP_CLIENT_CENTER_HOST_NZ,
  REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_CLIENTID,
  REACT_APP_AUTH0_AUS_DOMAIN,
  REACT_APP_AUTH0_AUS_CLIENTID,
  REACT_APP_AUTH0_NZ_DOMAIN,
  REACT_APP_AUTH0_NZ_CLIENTID,
} = process.env;

const AUTH0_EXTENSION = '/auth/auth0';

export const getLoginErrorMessage = (statusCode, email, failedAttempts) => {
  if (email.includes('gmail') && statusCode === 1003) {
    return 'Invalid email or password. Please try again. If you signed up using Google Sign-In, please use the same method to log in again.';
  }

  if (statusCode === 1003) {
    if (failedAttempts >= 1 && failedAttempts <= 5) {
      return 'There was an error signing you in. Please try again.';
    } else if (failedAttempts === 6) {
      return 'You have 2 login attempts remaining before your account will be locked.';
    } else if (failedAttempts === 7) {
      return 'You have 1 login attempt remaining before your account will be locked.';
    } else {

      return 'Invalid email or password. Please try again.';
    }
  }

  if (statusCode === 1005 && failedAttempts >= 8) {
    return 'Your account has been temporarily locked. Please wait for 10 minutes before attempting to log in again. If you require immediate assistance, please contact ';
  }

  return 'There was an error signing you in. Please try again.';
};

export const determineDomain = (useAuth0 = false) => {
  let host;
  if (window.origin.includes(NZ_DOMAIN)) {
    host = REACT_APP_CLIENT_CENTER_HOST_NZ;
  } else if (window.origin.includes(AUS_DOMAIN)) {
    host = REACT_APP_CLIENT_CENTER_HOST_AUS;
  } else {
    host = REACT_APP_CLIENT_CENTER_HOST;
  }
  return useAuth0 ? `${host}${AUTH0_EXTENSION}` : host;
};

export const determineAuth0DomainSettings = () => {
  const origin = window.location?.origin || window.origin || '';

  if (origin.includes(NZ_DOMAIN)) {
    return {
      domain: REACT_APP_AUTH0_NZ_DOMAIN,
      clientId: REACT_APP_AUTH0_NZ_CLIENTID
    };
  }

  if (origin.includes(AUS_DOMAIN)) {
    return {
      domain: REACT_APP_AUTH0_AUS_DOMAIN,
      clientId: REACT_APP_AUTH0_AUS_CLIENTID
    };
  }

  return {
    domain: REACT_APP_AUTH0_DOMAIN,
    clientId: REACT_APP_AUTH0_CLIENTID
  };
}

export const isUSDomain = () => (
  window.origin.includes(US_DOMAIN)
);
